import { gql } from "@apollo/client";

export const QUERY_DRIVER_GPS_DATA = gql`
  query getDriverGPSData {
    getDriverGPSData {
      driver
      gpsData {
        importIndex
        closestLat
        closestLon
      }
    }
  }
`;

export const SUBSCRIBE_DRIVER_GPS_DATA = gql`
  subscription newDriverGPSData {
    newDriverGPSData {
      driver
      gpsData {
        importIndex
        closestLat
        closestLon
      }
    }
  }
`;
